import { Component, Input, OnInit } from '@angular/core';
import {
  BarControllerDatasetOptions,
  ChartConfiguration,
  ChartData,
  ChartOptions,
  ChartType,
} from 'chart.js';
import { _DeepPartialObject } from 'chart.js/dist/types/utils';

@Component({
  selector: 'app-info-bar',
  templateUrl: './info-bar.component.html',
  styleUrls: ['./info-bar.component.css'],
})
export class InfoBarComponent implements OnInit {
  @Input() lable!: string;
  @Input() data: number[] = [10, 60];
  @Input() labels = ['Dummy 1 ', 'Dummy 2'];

  barChartOptions: any = {
    responsive: true,

    maintainAspectRatio: false,
    scales: {
      x: {
        stackWeight: 0.3,
      },
      y: {
        beginAtZero: true,
      },
      xAxes: [
        {
          barPercentage: 0.4,
        },
      ],
    },
    plugins: {
      title: { display: false },
      legend: { display: false },
      datalabels: {
        display: false,
      },
    },
  };
  barChartType: ChartType = 'bar';

  barChartData!: ChartData<'bar'>;
  constructor() {}

  ngOnInit() {
    this.barChartData = {
      labels: this.labels,
      datasets: [
        {
          data: this.data,
          label: 'المنجز',
          borderRadius: 10,
          borderWidth: 2,
          backgroundColor: ['#0D7167'],
        },
      ],
    };
  }
}
